<template>
  <div class="modal-wrapper cvLRVf dTIQsR">
    <div class="modal-backdrop fade in"></div>
    <div class="modal">
      <div class="modal-dialog">
        <div class="modal-content" @click.stop>
          <section class="jENZOg">
            <div></div>
            <div><h1>Login</h1></div>
            <div>
              <div class="close-button">
                <a @click="$emit('close')">
                  <svg class="hGsgfJ bnCywO" viewBox="0 0 32 32">
                    <path d="m6 6 20 20"></path>
                    <path d="m26 6-20 20"></path>
                  </svg>
                </a>
              </div>
            </div>
          </section>
          <div class="kkluyX">
            <div class="welcome-back-wrapper" style="padding: 0px">
              <div class="title">Welcome Back!</div>
              <div class="describe" style="padding: 0px">You'll be snagging in no time.</div>
              <div class="inputs-wrapper first">
                <div class="input-wrapper" :class="{ error: emailError }">
                  <div class="form-group">
                    <div class="">
                      <input
                        type="email"
                        v-model="email"
                        @blur="validateEmail"
                        @input="clearEmailError"
                        placeholder="Email address"
                        class="form-control"
                        style="font-size: 18px; margin-bottom: 35px"
                      />
                    </div>
                  </div>
                  <div class="input-dot"></div>
                  <!-- <div class="input-msg">The email must be a valid email address.</div> -->
                </div>
                <div class="input-wrapper" :class="{ error: passwordError }">
                  <div class="form-group">
                    <div class="">
                      <input
                        type="password"
                        v-model="password"
                        @blur="validatePassword"
                        @input="clearPasswordError"
                        placeholder="Password"
                        class="form-control"
                        style="font-size: 18px"
                      />
                    </div>
                  </div>
                  <div class="input-dot"></div>
                  <!-- <div class="input-msg">The password must be at least 8 characters.</div> -->
                </div>
              </div>
              <div class="forgot-password" @click="$emit('showForgotPassword')">Forgot your password?</div>
              <div class="btns-wrapper">
                <button class="qtvwz" :disabled="!isFormValid" :style="isFormValid ? 'background: rgb(0, 0, 0); cursor: pointer;' : ''" @click="handleLogin">Log in</button>
                <!-- <a href="">
                  <img src="/static/images/header/facebook.svg" style="width: 38.4px" />
                </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userStore from '../../store/user.js'
import { userApi } from '../../api/index.js'

export default {
  name: 'LoginModal',
  data() {
    return {
      email: '',
      password: '',
      emailError: false,
      passwordError: false,
      isSubmitting: false
    }
  },
  computed: {
    isFormValid() {
      return this.email && this.password && this.password.length >= 6 && this.isValidEmail(this.email)
    }
  },
  methods: {
    isValidEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    },
    validateEmail() {
      if (!this.email || !this.isValidEmail(this.email)) {
        this.emailError = true
      } else {
        this.emailError = false
      }
    },
    validatePassword() {
      if (!this.password || this.password.length < 6) {
        this.passwordError = true
      } else {
        this.passwordError = false
      }
    },
    clearEmailError() {
      if (this.email) {
        this.emailError = false
      }
    },
    clearPasswordError() {
      if (this.password) {
        this.passwordError = false
      }
    },
    async handleLogin() {
      if (!this.isFormValid || this.isSubmitting) {
        return
      }

      this.isSubmitting = true

      try {
        // 调用登录 API
        const formData = new FormData()
        formData.append('email', this.email)
        formData.append('password', this.password)
        formData.append('type', 1) // 1:买家

        const response = await userApi.login(formData)
        
        if (response.code === 1) {
          // 登录成功，保存用户信息
          userStore.login(response.data)
          this.$toast('Login successful!')
          this.$emit('close')
        } else {
          this.$toast(response.msg || 'Login failed, please try again', 3000)
        }
      } catch (error) {
        console.error('Login error:', error)
        this.$toast('Login failed: ' + (error.message || 'Network error, please try again'), 3000)
      } finally {
        this.isSubmitting = false
      }
    },
    handleBackdropClick() {
      this.$emit('close')
    }
  }
}
</script>
